"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createMetadataTelemetryInitializer = void 0;
/**
 * Creates an initializer for adding metadata to dependency telemetry events.
 *
 * @param ai - The Application Insights client instance to attach the dependency initializer to
 * @returns A function that can be called to update the metadata
 *
 * @example
 * ```typescript
 * const ai = new ApplicationInsights();
 * const updateMetadata = createMetadataTelemetryInitializer(ai);
 *
 * // Later, update metadata
 * updateMetadata({ userId: '123', environment: 'prod' });
 * ```
 */ var createMetadataTelemetryInitializer = function(ai) {
    var _window___NEXT_DATA__;
    // Ensure __NEXT_DATA__ exists before accessing
    var page = typeof window !== 'undefined' ? (_window___NEXT_DATA__ = window.__NEXT_DATA__) === null || _window___NEXT_DATA__ === void 0 ? void 0 : _window___NEXT_DATA__.page : undefined;
    var referrer = window.document.referrer;
    var currentMetadata = {}; // initial metadata
    ai.addTelemetryInitializer(function(envelope) {
        if (envelope.data) {
            var _envelope_data;
            var _ref = (_envelope_data = envelope.data) !== null && _envelope_data !== void 0 ? _envelope_data : {}, properties = _ref.properties, restData = _object_without_properties(_ref, [
                "properties"
            ]); //
            // eslint-disable-next-line no-param-reassign -- we need to modify the envelope
            envelope.data = _object_spread({}, restData, properties, currentMetadata, typeof page === 'string' ? {
                nextInternalUrl: page
            } : {}, referrer && referrer.length > 0 ? {
                referer: referrer
            } : {});
        }
        return true;
    });
    // Return function to update metadata
    return function(newMetadata) {
        Object.assign(currentMetadata, newMetadata);
    };
};
exports.createMetadataTelemetryInitializer = createMetadataTelemetryInitializer; //# sourceMappingURL=createMetadataTelemetryInitializer.js.map
